(function () {
  if (window.__ourosFooterAccordion) return;
  window.__ourosFooterAccordion = true;

  var mq = window.matchMedia('(max-width: 480px)');

  function setState(heading, open) {
    var list = heading.nextElementSibling;
    heading.classList.toggle('activ', open);
    heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (list && list.classList.contains('footer-block__details-content')) {
      list.classList.toggle('activ', open);
    }
  }

  function init() {
    document.querySelectorAll('h2.menu-heading').forEach(function (h) {
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', h.classList.contains('activ') ? 'true' : 'false');
    });
  }

  function toggle(heading) {
    if (!mq.matches) return;
    setState(heading, !heading.classList.contains('activ'));
  }

  // Event delegation: works even if the section re-renders in the theme editor
  document.addEventListener('click', function (e) {
    var heading = e.target.closest('h2.menu-heading');
    if (heading) toggle(heading);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var heading = e.target.closest('h2.menu-heading');
    if (heading) {
      e.preventDefault();
      toggle(heading);
    }
  });

  // Reset when leaving mobile view
  mq.addEventListener('change', function (e) {
    if (!e.matches) {
      document.querySelectorAll('h2.menu-heading').forEach(function (h) {
        setState(h, false);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();